import React from 'react'
import ReactECharts from 'echarts-for-react';
import "echarts-wordcloud";
import axios from 'axios';
import { osintRequestAddress } from '../../config'

const WordCloud = (props) => {
    const wordOption = () => {
        let option = {
            backgroundColor: "#001",
            tooltip: {
                pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            series: [
                {
                    type: "wordCloud",
                    shape: 'square',
                    keepAspect: false,
                    // drawOutOfBound: false,
                    gridSize: 0,
                    sizeRange: [24, 60],
                    autoSize: {
                        enable: true,
                        minSize: 4
                    },
                    rotationRange: [-90, 90],
                    rotationStep: 45,
                    textStyle: {
                        fontFamily: 'sans-serif',
                        // fontWeight: 'bold',
                        // Color can be a callback function or a color string
                        color: function () {
                            // Random color
                            return 'rgb(' + [
                                Math.round(64 + Math.random() * 192),
                                Math.round(64 + Math.random() * 192),
                                Math.round(64 + Math.random() * 192),
                            ].join(',') + ')';
                        }
                    },
                    emphasis: {
                        focus: 'self',
                        textStyle: {
                            textShadowBlur: 10,
                            textShadowColor: '#333'
                        }
                    },
                    left: "center",
                    top: "center",
                    right: null,
                    bottom: null,
                    width: "90%",
                    height: "110%",
                    data: props.wordData
                }
            ]
        };
        return option;
    };

    const onWordCloudClick = (param) => {
        if (param.data) {
            const { name } = param.data
            axios.get(`${osintRequestAddress}/tw?wordfreqrange=1&screenName=${props.screenName}&keyword=${name}`).then(
                response => {
                    if (response.data) {
                        if (response.data.length > param.data.value){
                            props.setTweetsList(`包含关键词"${name}"的推文：`, response.data.slice(0,param.data.value))
                        }else{
                            props.setTweetsList(`包含关键词"${name}"的推文：`, response.data)
                        }                        
                    }
                },
                error => { console.log("error", error) }
            )
        }
    }

    return props.wordData && props.wordData.length>0 ? <ReactECharts option={wordOption()} theme='ThemeStyle' onEvents={{ 'click': onWordCloudClick }}/>:''
}

export default WordCloud;
